import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { statesAdminV2Service } from '../services/states-admin-v2.service'

/**
 * Estados activos (`{ id: sta_, … }`) para la matriz de permisos del editor de
 * roles v2. Sólo corre con sesión staff v2 y se cachea largo: el catálogo de
 * estados cambia poco.
 *
 * Reemplaza el uso de `useStatesLookupQuery` (v1) desde el editor v2, que estaba
 * ahí sólo para leerle el `publicId`. El lookup v1 sigue vivo para negotiations
 * y workflows, que bindean `_id` y lo mandan a endpoints v1: cambiarlos acá les
 * mandaría un `sta_` donde esperan un ObjectId y **no darían error, devolverían
 * vacío**. Cada uno muere cuando se migra su módulo.
 */
export const useStatesV2LookupQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.states.lookupV2(),
    queryFn: async () => await statesAdminV2Service.lookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
